import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "src/hooks/useAuth";
import { 
  checkRouteAccess, 
  isPublicRoute,
  getAccessibleRoutes
} from "src/utils/routePermission";
import FallbackSpinner from "src/@core/components/spinner";

const ProtectedRoute = ({ children }) => {
  const { user, userType, permissionsWithNames, loading, permissionsLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while auth is initializing or permissions are loading
  if (loading || (userType === "sub_admin" && permissionsLoading)) {
    return <FallbackSpinner />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const currentPath = location.pathname;
  
  // Check if it's a public authenticated route
  if (isPublicRoute(currentPath)) {
    return children;
  }

  // If user is admin, allow access to all routes
  if (userType === "admin") {
    return children;
  }

  // Check if user has access to the current route
  const hasRouteAccess = checkRouteAccess(currentPath, permissionsWithNames);

  if (!hasRouteAccess) {
    return <Navigate to="/401" replace />;
  }

  return children;
};

export { getAccessibleRoutes };
export default ProtectedRoute; 